import React, { Suspense, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import useAxios from "axios-hooks";

import LocationDetailsTabs from "./tabs/LocationDetailsTabs";
import LoadingSpinner from "components/feedback/LoadingSpinner";
import logger from "infra/logger";

const ViewLocation = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [location, setLocation] = useState(null);
  const [{ data, loading, error }, getLocation] = useAxios(
    { method: "GET", url: `/api/locations/${id}` },
    { manual: true }
  );

  const fetchLocation = async () => {
    try {
      const response = await getLocation();
      setLocation(response.data.data);
    } catch (error) {
      logger.log(error);
    }
  };

  useEffect(() => {
    fetchLocation();
  }, []);

  return (
    <Suspense fallback={<LoadingSpinner />}>
      <LocationDetailsTabs
        id={id}
        data={location}
        getLocation={fetchLocation}
      />
    </Suspense>
  );
};

export default ViewLocation;
